/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caseslistnew2Inputs */

const en_caseslistnew2 = /** @type {(inputs: Caseslistnew2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New case`)
};

const pt_caseslistnew2 = /** @type {(inputs: Caseslistnew2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo caso`)
};

/**
* | output |
* | --- |
* | "New case" |
*
* @param {Caseslistnew2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const caseslistnew2 = /** @type {((inputs?: Caseslistnew2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caseslistnew2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_caseslistnew2(inputs)
	return pt_caseslistnew2(inputs)
});
export { caseslistnew2 as "casesListNew" }